import React, {Fragment, useContext, useEffect, useRef, useState} from 'react';
import Modal from "react-bootstrap/Modal";
import {Col, Container, Dropdown, Form, Spinner, Image, ProgressBar, Button, Card, ButtonGroup} from "react-bootstrap";
import { Context } from "../../index";
import { observer } from "mobx-react-lite";
import {
    fetchCurrentUserBooks,
} from "../../http/bookAPI";
import Row from "react-bootstrap/Row";
import AvatarEditor from 'react-avatar-editor';
import defaultImage from "../../assets/empty-product.jpg";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {getRedirectUrlApi} from "../../http/userAPI";
import CacheUpdateModal from "../../helpers/CacheUpdateModal";


const addProductInDashboard = observer(({ }) => {
    const { book } = useContext(Context);
    const { user } = useContext(Context);

    const [titleState, setTitleState] = useState('');
    const [subtitleState, setSubTitleState] = useState('');
    const [authorState, setAuthorState] = useState('');
    const [summaryState, setSummaryState] = useState('');
    const [originalCover, setOriginalCover] = useState(null); // Оригинальный файл
    const [coverFileState, setCoverFileState] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [coverPreview, setCoverPreview] = useState(defaultImage);
    const [amzlinkState, setAmzlinkState] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [showEditor, setShowEditor] = useState(false); // Управление отображением редактора
    const [scale, setScale] = useState(1);
    const [editorRef, setEditorRef] = useState(null);
    const [editorSize, setEditorSize] = useState({ width: 240, height: 240 });
    const [bookFormat, setBookFormat] = useState("1x1");

    const [kindlePriceState, setKindlePriceState] = useState('');
    const [paperbackPriceState, setPaperbackPriceState] = useState('');
    const [hardcoverPriceState, setHardcoverPriceState] = useState('');
    const [fourthPriceState, setFourthPriceState] = useState('');

    const [noManuscript, setNoManuscript] = useState(false);
    const [publicCatalogVisible, setPublicCatalogVisible] = useState(true);

    const [paperbackAsinState, setPaperBackAsinState] = useState('');
    const [kindleAsinState, setKindleAsinState] = useState('');
    const [hardcoverAsinState, setHardCoverAsinState] = useState('');
    const [audioAsinState, setAudioAsinState] = useState('');
    const [audibleAsinState, setAudibleAsinState] = useState('');
    const [audioBookLinkState, setAudioBookLinkState] = useState('');
    const [selectedWordCount, setSelectedWordCount ] = useState({
        id: 1, count: 10000, label: "About 10,000"
    });

    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState("");

    const parentRef = useRef(null);

    const [newBook, setNewdBook] = useState({
        message_flag: false,
        paper_back_flag: false,
        kindle_flag: true,
        kindle_unlimited_flag: false,
        hard_cover_flag: false,
        audio_flag: false,
        audio_exclusive_flag: false,
        audio_non_exclusive_flag: false,
        cover_file: null,
        summary: null,
        book_file: null,
        bp_asin: null,
        k_asin: null,
        hc_asin: null,
        audio_asin: null,
        book_temp_file: null,

    });

    const [step, setStep] = useState(0); // Хранит текущий шаг
    const [nextStep, setNextStep] = useState({
        step0: true,
        step1: false,
        step2: false,
        step3: false,
        step4: false,
        step5: false,
        step6: false,
    });

    const wordCountOptions = [
        { id: 1, count: 1000, label: "About 1,000" },
        { id: 2, count: 5000, label: "About 5,000" },
        { id: 3, count: 10000, label: "About 10,000" },
        { id: 4, count: 15000, label: "About 15,000" },
        { id: 5, count: 20000, label: "About 20,000" },
        { id: 6, count: 25000, label: "About 25,000" },
        { id: 7, count: 30000, label: "About 30,000" },
        { id: 8, count: 35000, label: "About 35,000" },
        { id: 9, count: 40000, label: "About 40,000" },
        { id: 10, count: 45000, label: "About 45,000" },
        { id: 11, count: 50000, label: "About 50,000" },
        { id: 12, count: 60000, label: "About 60,000" },
        { id: 13, count: 75000, label: "About 75,000" },
        { id: 14, count: 85000, label: "About 85,000" },
        { id: 15, count: 100000, label: "About 100,000" },
        { id: 16, count: 120000, label: "More then 120,000" },

    ];



    // 📌 Соотношения сторон для разных форматов книг
    const bookSizes = {
        "1x1": { aspectRatio: 1 },
        "4x5": { aspectRatio: 4 / 5 },
        "3x4": { aspectRatio: 3 / 4 },
        "2x3": { aspectRatio: 2 / 3 },
        "16x9": { aspectRatio: 16 / 9 },
        "5x4": { aspectRatio: 5 / 4 },
    };
    const [pdffile, setPdfFile] = useState(null)
    const [tempPDFFile, setTempPDFFile] = useState(''); // Для временного файла
    const [uploadProgress, setUploadProgress] = useState(0); // Для прогресса загрузки
    const [pdfFileTitle, setPdfFileTitle] = useState("")

    // 🔹 Функция обновления размеров (по `bookFormat` и при `resize`)
    useEffect(() => {
        const updateSize = () => {
            if (parentRef.current) {
                const parentWidth = parentRef.current.clientWidth;
                const selectedSize = bookSizes[bookFormat] || bookSizes["1x1"];
                const newHeight = parentWidth / selectedSize.aspectRatio;
                setEditorSize({ width: parentWidth, height: newHeight });
            }
        };

        updateSize();
        window.addEventListener("resize", updateSize);
        return () => window.removeEventListener("resize", updateSize);
    }, [bookFormat]); // Обновление при изменении формата книги

    useEffect(() => {
        const savedPdfFileTitle = localStorage.getItem("pdf_file_title");
        const savedTempPDFFile = localStorage.getItem("temp_pdf_file");

        if (savedPdfFileTitle) setPdfFileTitle(savedPdfFileTitle);
        if (savedTempPDFFile) setTempPDFFile(savedTempPDFFile);
    }, []);

    useEffect(() => {
        loadBookDataFromLocalStorage();
    }, []);


    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;

        setNewdBook((prevBook) => {
            let updatedBook = { ...prevBook, [name]: checked };

            // Если выбрали "Exclusive", отключаем "Non-Exclusive"
            if (name === "audio_exclusive_flag" && checked) {
                updatedBook.audio_non_exclusive_flag = false;
            }

            // Если выбрали "Non-Exclusive", отключаем "Exclusive"
            if (name === "audio_non_exclusive_flag" && checked) {
                updatedBook.audio_exclusive_flag = false;
            }

            // Если отжали Аудио, отключаем оба флага
            if (name === "audio_flag" && !checked) {
                updatedBook.audio_exclusive_flag = false;
                updatedBook.audio_non_exclusive_flag = false;
            }

            // Если отжали Kindle, отключаем Kindle Unlimited
            if (name === "kindle_flag" && !checked) {
                updatedBook.kindle_unlimited_flag = false;
            }

            return updatedBook;
        });
    };


    const isFormValid =
        user.user.id &&
        book.selectedGenre.id &&
        book.selectedLanguage.id &&
        titleState &&
        subtitleState &&
        authorState &&
        summaryState &&
        (newBook.paper_back_flag ||
            newBook.kindle_flag ||
            newBook.hard_cover_flag ||
            newBook.audio_flag) &&
        (paperbackAsinState || kindleAsinState || hardcoverAsinState || audioAsinState) &&
        coverFileState;



    const handleSubmitBookToModeration = () => {
        // Тримим значения прямо перед отправкой
        const trimmedTitle = titleState.trim();
        const trimmedAuthor = authorState.trim();
        const trimmedSubtitle = subtitleState.trim();

        // Обновляем состояния (чтобы на экране тоже показались триммированные значения, если нужно)
        setTitleState(trimmedTitle);
        setAuthorState(trimmedAuthor);
        setSubTitleState(trimmedSubtitle);

        if (!isFormValid) {
            toast.warn("Fill all fields, please!", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            return;
        }

        addBook();

    };



    const handleStepsChange = (step) => {
        let error = "";

        // 🔥 Проверяем, какие поля нужны для каждого шага
        if (step === 1 && (!titleState || !subtitleState || !authorState)) {
            toast.info(`Enter Title, Manufacturer and Seller!`,{ position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            return;

        } else if (step === 2 &&
            (!book.selectedLanguage.language || !book.selectedGenre.genre ||
                !(newBook.paper_back_flag || newBook.kindle_flag || newBook.hard_cover_flag || newBook.audio_flag))
        ) {
            toast.info(`Set Language and Category!`,{ position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            return;
        } else if (step === 3 && !coverFileState) {
            toast.info(`Please Upload Product Image!`,{ position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            return;
        } else if (step === 4 && !summaryState) {
            toast.info(`Enter the Summary of Product!`,{ position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            return;
        } else if (step === 2 && newBook.kindle_flag === true && (!kindleAsinState || !kindlePriceState)) {
            toast.info(`Please enter First ASIN & Price!`, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            return;
        } else if (step === 2 && newBook.paper_back_flag === true && (!paperbackAsinState || !paperbackPriceState)) {
            toast.info(`Enter a Second ASIN & Price!`,{ position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            return;
        } else if (step === 2 && newBook.hard_cover_flag === true && (!hardcoverAsinState || !hardcoverPriceState)) {
            toast.info(`Please enter a Third ASIN & Price!`,{ position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            return;
        } else if (step === 2 && newBook.audio_flag === true && (!audioAsinState || !fourthPriceState)) {
            toast.info(`Please enter a Fourth ASIN & Price!`,{ position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            return;
        }

        if (error) {
            setToastMessage(error); // Устанавливаем сообщение
            setShowToast(true); // Показываем тост
            return; // ❌ Прерываем смену шага
        }

        // ✅ Если все условия выполнены, передаем актуальные данные
        saveBookDataToLocalStorage({
            title: titleState,
            subtitle: subtitleState,
            author: authorState,
            language: book.selectedLanguage,
            genre: book.selectedGenre,
            audio_book_link: audioBookLinkState,

            summary: summaryState,
            pb_asin: paperbackAsinState,
            k_asin: kindleAsinState,
            hc_asin: hardcoverAsinState,
            audio_asin: audioAsinState,
            audible_asin: audibleAsinState,
            audible_link: audioBookLinkState,


            bookTypes: {
                paperBack: newBook.paper_back_flag,
                kindle: newBook.kindle_flag,
                kindle_u: newBook.kindle_unlimited_flag,
                hardCover: newBook.hard_cover_flag,
                audio: newBook.audio_flag,
                audio_ex: newBook.audio_exclusive_flag,
                audio_non_ex: newBook.audio_non_exclusive_flag,
            }
        });

        setNextStep((prev) => {
            const updatedSteps = Object.keys(prev).reduce((acc, key) => {
                acc[key] = false; // Сбрасываем все шаги в false
                return acc;
            }, {});

            return {
                ...updatedSteps,
                [`step${step}`]: true, // Включаем только текущий шаг
            };
        });

        setStep(step);
    };


// Функция сохранения данных анкеты в localStorage
    const saveBookDataToLocalStorage = (updatedFields = {}) => {
        const existingData = JSON.parse(localStorage.getItem("productForm")) || {};

        const bookData = {
            ...existingData, // Берем старые данные
            ...updatedFields, // Обновляем только измененные поля
        };
        if (updatedFields.no_manuscript !== undefined) {
            bookData.no_manuscript = updatedFields.no_manuscript ? true : false;
        }
        if (updatedFields.public_catalog_visible !== undefined) {
            bookData.public_catalog_visible = updatedFields.public_catalog_visible ? true : false;
        }
        localStorage.setItem("productForm", JSON.stringify(bookData));
    };


    const loadBookDataFromLocalStorage = () => {
        const savedData = localStorage.getItem("productForm");
        if (savedData) {
            const bookData = JSON.parse(savedData);
            setTitleState(bookData.title || "");
            setSubTitleState(bookData.subtitle || "");
            setAuthorState(bookData.author || "");
            setSummaryState(bookData.summary || "");
            setPaperBackAsinState(bookData.pb_asin || "");
            setKindleAsinState(bookData.k_asin || "");
            setHardCoverAsinState(bookData.hc_asin || "");
            setAudioAsinState(bookData.audio_asin || "");
            setAudibleAsinState(bookData.audible_asin || "");
            setAudioBookLinkState(bookData.audible_link || "");

            if (bookData.no_manuscript !== undefined) {
                setNoManuscript(!!bookData.no_manuscript);
            }
            if (bookData.public_catalog_visible !== undefined) {
                setPublicCatalogVisible(bookData.public_catalog_visible !== false);
            }

            setTempPDFFile(bookData.temp_pdf_file || "");
            setPdfFileTitle(bookData.pdf_file_title || "");


            // ✅ Загружаем обложку (если есть)
            if (bookData.cover_file) {
                const restoredBlob = base64ToBlob(bookData.cover_file);
                const restoredFile = new File([restoredBlob], bookData.cover_file_name, { type: "image/jpeg" });

                setCoverFileState(restoredFile); // Теперь `coverFileState` — это `File`
                setCoverPreview(bookData.cover_file);

            }


            // ✅ Загружаем язык и жанр
            book.setSelectedLanguage(bookData.language || {});
            book.setSelectedGenre(bookData.genre || {});

            setNewdBook((prev) => ({
                ...prev,
                paper_back_flag: bookData.bookTypes?.paperBack || false,
                kindle_flag: bookData.bookTypes?.kindle || false,
                hard_cover_flag: bookData.bookTypes?.hardCover || false,
                kindle_unlimited_flag: bookData.bookTypes?.kindle_u || false,
                audio_flag: bookData.bookTypes?.audio || false,
                audio_exclusive_flag: bookData.bookTypes?.audio_ex || false,
                audio_non_exclusive_flag: bookData.bookTypes?.audio_non_ex || false,
            }));
        }
    };


    const clearBookDataFromLocalStorage = () => {
        localStorage.removeItem("productForm"); // Удаляем сохраненные данные книги
    };


// ✅ Функция загрузки файла
    const selectBookFile = (e) => {
        const input = e.target;
        const file = input.files[0];

        // Сброс input, чтобы можно было повторно выбрать тот же файл
        input.value = "";

        if (!file) {
            toast.error("Error: No file selected.", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            return;
        }

        // 🔹 Проверка формата и размера файла
        if (file.type !== "application/pdf") {
            toast.error(`Error: File "${file.name}" is not a PDF.`, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            return;
        }

        const maxFileSize = 500 * 1024 * 1024; // 500MB in bytes
        if (file.size > maxFileSize) {
            toast.error(`Error: File "${file.name}" exceeds 500MB limit.`, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            return;
        }

        // 🔹 Обновляем состояние файла
        setPdfFile(file);
        setPdfFileTitle(file.name); // Save the original file name

        // ✅ Save to `localStorage`
        saveBookDataToLocalStorage({
            pdf_file_title: file.name, // Save Base64 instead of an object
        });

        // 🔹 Создаем `FormData` и загружаем файл
        const formData = new FormData();
        formData.append("book_download_temp", file);

        try {
            const xhr = new XMLHttpRequest();
            xhr.open("POST", process.env.REACT_APP_API_URL + "api/book/temp", true);

            // 🔹 Обработчик прогресса
            xhr.upload.onprogress = (event) => {
                if (event.lengthComputable) {
                    const percentComplete = Math.round((event.loaded / event.total) * 100);
                    setUploadProgress(percentComplete >= 100 ? 99 : percentComplete);
                }
            };

            // 🔹 Обработчик завершения загрузки
            xhr.onload = () => {
                if (xhr.status === 200) {


                    const response = JSON.parse(xhr.responseText);
                    const tempFileName = response.tempPDFFile;

                    toast.success(response.message, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });

                    // 🔹 Save temporary file name
                    setTempPDFFile(tempFileName);

                    // ✅ Save to `localStorage`
                    saveBookDataToLocalStorage({
                        temp_pdf_file: tempFileName, // Save temporary file name
                    });

                    setUploadProgress(100);
                } else {
                    let errorMessage = `Upload failed: ${xhr.status}`;
                    try {
                        errorMessage = JSON.parse(xhr.responseText)?.message || errorMessage;
                    } catch (_) {}
                    toast.error(errorMessage, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                    setUploadProgress(-1);
                }
            };

            // 🔹 Обработчик ошибок
            xhr.onerror = () => {
                toast.error("Error uploading file.", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                setUploadProgress(-1);
            };

            // 🔹 Отправляем файл на сервер
            xhr.send(formData);
        } catch (error) {
            toast.error(`Error sending file: ${error.message}`, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
        }
    };

// ✅ Функция для клика по скрытому input
    const triggerFileInputBook = () => {
        document.getElementById("fileInputBook").click();
    };

    const triggerFileInput = () => {
        const input = document.getElementById("fileInput");
        input.value = ""; // 🧹 сбрасываем значение
        input.click();
    };

    const handleFileChange = (e) => {
        const input = e.target;
        const file = e.target.files[0];
        input.value = "";
        if (file && file.type.startsWith("image/")) {
            setOriginalCover(file);
            const reader = new FileReader();
            reader.onload = (event) => {
                const imageBase64 = event.target.result;

                setCoverPreview(imageBase64);
                setShowEditor(true);

                // ✅ Сохраняем в `localStorage`
                saveBookDataToLocalStorage({
                    cover_file: imageBase64, // Сохраняем Base64 вместо объекта
                    cover_file_name: file.name,
                });


            };
            reader.readAsDataURL(file);
        }
    };

    const base64ToBlob = (base64) => {
        const byteCharacters = atob(base64.split(',')[1]); // Убираем `data:image/jpeg;base64,`
        const byteArrays = [];
        for (let i = 0; i < byteCharacters.length; i++) {
            byteArrays.push(byteCharacters.charCodeAt(i));
        }
        return new Blob([new Uint8Array(byteArrays)], { type: 'image/jpeg' });
    };


    const handleSave = () => {
        if (editorRef) {
            try {
                const canvas = editorRef.getImageScaledToCanvas();
                canvas.toBlob(
                    (blob) => {
                        if (blob) {
                            const reader = new FileReader();
                            reader.onload = (event) => {
                                const editedImageBase64 = event.target.result;

                                setCoverPreview(editedImageBase64);
                                setCoverFileState(blob);
                                setShowEditor(false);

                                // ✅ Обновляем данные в `localStorage`
                                saveBookDataToLocalStorage({
                                    cover_file: editedImageBase64,
                                    cover_file_prev: editedImageBase64,
                                });


                            };
                            reader.readAsDataURL(blob);
                        } else {

                        }
                    },
                    'image/jpeg',
                    0.9
                );
            } catch (error) {

            }
        } else {

        }
    };

    const resetDataFields = () => {
        // Очистка localStorage
        localStorage.removeItem("temp_pdf_file");

        // Сброс файла книги
        setTempPDFFile(null);
        setPdfFileTitle('');

        // Сброс данных книги
        setTitleState('');
        setSubTitleState('');
        setAuthorState('');
        setSummaryState('');
        setAmzlinkState('');
        setPaperBackAsinState('');
        setKindleAsinState('');
        setHardCoverAsinState('');
        setAudioAsinState('');
        setAudibleAsinState('');
        setAudioBookLinkState('');
        setPdfFile(null);
        setSelectedWordCount({});


        // Сброс выбора языка и жанра
        book.setSelectedLanguage({});
        book.setSelectedGenre({});

        // Сброс флагов и обложки
        setCoverFileState(null);
        setCoverPreview(defaultImage);
        setOriginalCover(null);
        setShowEditor(false);
        setScale(1);

        // Очистка редактора
        setEditorRef(null);
    };




    const addBook = async () => {
        setLoading(true);
        setError('');


        try {
            const formData = new FormData();

            // ===== Price normalization helpers =====
            const normalizePrice = (val) => {
                if (val === undefined || val === null) return '';
                let s = String(val).trim();
                if (!s) return '';

                // remove spaces and currency symbols, keep digits, comma, dot, minus
                s = s.replace(/\s+/g, '').replace(/[^\d.,-]/g, '');

                // optional: forbid negative (strip all minus)
                s = s.replace(/-/g, '');

                // if there is neither comma nor dot → it's an integer already
                const lastComma = s.lastIndexOf(',');
                const lastDot   = s.lastIndexOf('.');
                if (lastComma === -1 && lastDot === -1) return s;

                // choose the rightmost of comma/dot as decimal separator
                const decPos = Math.max(lastComma, lastDot);
                const intPart  = s.slice(0, decPos).replace(/[.,]/g, ''); // remove thousands separators
                const fracPart = s.slice(decPos + 1).replace(/[.,]/g, ''); // keep only digits

                return fracPart ? `${intPart}.${fracPart}` : intPart; // "1234.56" or "1234"
            };

            const toPriceNumber = (val) => {
                const norm = normalizePrice(val);
                if (!norm) return undefined;
                const n = Number(norm);
                return Number.isFinite(n) ? n : undefined;
            };

            // ===== Price-specific append helpers (normalized) =====
            const appendPriceString = (key, value) => {
                const norm = normalizePrice(value);
                if (norm) formData.append(key, norm);
            };

            const appendPriceNumber = (key, value) => {
                const n = toPriceNumber(value);
                if (n !== undefined) formData.append(key, n);
            };

            // 📌 Заполняем formData
            formData.append('userId', user.user.id);
            formData.append('booksGenreId', book.selectedGenre.id);
            formData.append('booksPriceId', 1);
            formData.append('booksLanguageId', book.selectedLanguage.id);
            formData.append('booksTypeId', 1);
            formData.append('title', titleState);
            formData.append('subtitle', subtitleState);
            formData.append('author', authorState);
            formData.append('book_type', 'product');
            formData.append('language', book.selectedLanguage.language);
            formData.append('amz_price', '');
            formData.append('summary', summaryState);
            formData.append('status', 'NEW');
            formData.append('message', '');
            formData.append('message_flag', false);
            formData.append('amz_link', '');
            formData.append('paper_back_flag', newBook.paper_back_flag);
            formData.append('kindle_flag', newBook.kindle_flag);
            formData.append('kindle_unlimited_flag', newBook.kindle_unlimited_flag);
            formData.append('audio_exclusive_flag', newBook.audio_exclusive_flag);
            formData.append('audio_non_exclusive_flag', newBook.audio_non_exclusive_flag);
            formData.append('hard_cover_flag', newBook.hard_cover_flag);
            formData.append('audio_flag', newBook.audio_flag);
            formData.append('default_price', 500);
            formData.append('default_decrement', 0);
            formData.append('paper_back_asin', paperbackAsinState || '');
            formData.append('kindle_asin', kindleAsinState || '');
            formData.append('hard_cover_asin', hardcoverAsinState || '');
            formData.append('audio_asin', audioAsinState || '');
            formData.append('audio_audible_asin', audibleAsinState || '');
            formData.append('audio_download_link_ned', audioBookLinkState || '');
            formData.append('total_words', selectedWordCount?.count || 1000);
            formData.append('no_manuscript', 1);
            formData.append('public_catalog_visible', publicCatalogVisible ? '1' : '0');

            // ===== Prices (strings – normalized with dot) =====
            appendPriceString("kindle_price_on_amazon", kindlePriceState);
            appendPriceString("paper_back_price_on_amazon", paperbackPriceState);
            appendPriceString("hard_cover_price_on_amazon", hardcoverPriceState);
            appendPriceString("fourth_price_on_amazon", fourthPriceState);

            // ===== Prices (numbers – normalized) =====
            appendPriceNumber('kindle_list_price_on_amazon_decimal', kindlePriceState);
            appendPriceNumber('paper_back_list_price_on_amazon_decimal', paperbackPriceState);
            appendPriceNumber('hard_cover_list_price_on_amazon_decimal', hardcoverPriceState);
            appendPriceNumber('fourth_list_price_on_amazon_decimal', fourthPriceState);


            // 📎 Добавляем PDF-файл
            if (tempPDFFile) {
                formData.append("book_download", tempPDFFile);
            }

            // 📎 Добавляем обложку
            if (coverFileState) {
                formData.append("cover_file", coverFileState);
            } else {
                toast.warn("No cover image found!", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            }

            // 🚀 Отправляем данные через fetch
            const response = await fetch(`${process.env.REACT_APP_API_URL}api/book/`, {
                method: 'POST',
                body: formData,
            });

            if (!response.ok) {
                throw new Error(`Server returned ${response.status}`);
            }

            const result = await response.json();
            const createdBook = result.book;

            toast.success(result.message, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });

            // 🔄 Обновляем список книг
            const updatedBooks = await fetchCurrentUserBooks(user?.user?.id);
            book.setCurrentUserBooks(updatedBooks);
            book.setSelectedCurrentUserBook({formData});



            // ✅ Устанавливаем выбранную книгу
            const foundBook = updatedBooks.find(b => b.id === createdBook.id);
            if (foundBook) {


                book.setSelectedCurrentUserBook(foundBook);
                user.setActiveComponent("BookFull");
            }

            clearBookDataFromLocalStorage();
            resetDataFields();

        } catch (e) {
            console.error(e);
            toast.error(`❌ Error: ${e.message}`, { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
            setError(e.message || 'An error occurred while uploading your book.');
        } finally {
            setLoading(false);


        }
    };


    useEffect(() => {
        if (error) {
            toast.error(`❌ ${error}`, { closeOnClick: true, pauseOnHover: true, draggable: true, theme: 'colored', position: "bottom-center", autoClose: 3000, hideProgressBar: false });
        }
    }, [error]);

    const addProductInDash = () => {
        user?.setActiveComponent("AddProductInDashboard");
    }
    const autoAddProductInDash = () => {
        user?.setActiveComponent("AddProductByGrabFromAmazon");
    }

    return (
        <>
            <Card className="p-3 w-100 mt-2">
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center flex-wrap gap-2">
                    {/* Header: title + Back button on step > 0 */}
                    <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center flex-wrap gap-2 w-100">
                        <h5 className="text-muted mb-2 mb-md-0">
                            Manually Add a New FBA Product to Virtalibry System:
                        </h5>

                        {/* Кнопки Manual / Automatic справа */}
                        <ButtonGroup>
                            <Button
                                variant={user?.activeComponent === "AddProductByGrabFromAmazon" ? "success" : "outline-success"}
                                size="sm"
                                onClick={autoAddProductInDash}
                            >
                                Automatically
                            </Button>
                            <Button
                                variant={user?.activeComponent === "AddProductInDashboard" ? "success" : "outline-success"}
                                size="sm"
                                onClick={addProductInDash}
                            >
                                Manually
                            </Button>
                        </ButtonGroup>

                    </div>
                    <Col md={12} className="">

                        {nextStep.step0 ? (
                            <>
                                <div className="text-muted small">
                                    <p className="mb-1">
                                        This page lets you manually add your physical product to Virtalibry in a simple, step-by-step way.
                                        It only takes a couple of minutes.
                                    </p>

                                    <p className="mb-1">
                                        <strong>Step 1:</strong> Enter your <em>Product Name</em><br />
                                        <strong>Step 2:</strong> Add the <em>Brand</em> or <em>Manufacturer</em><br />
                                        <strong>Step 3:</strong> Specify the main <em>Category</em> or <em>Type</em> (for example, Earplugs, Headphones, or Fitness Accessory)
                                    </p>

                                    <p className="mb-1">
                                        <strong>Note:</strong> Only the following characters are allowed in text fields:
                                    </p>

                                    <p className="mb-1">
                                        <code>a–z, A–Z, 0–9, spaces, apostrophes (’), dashes (-), and these symbols: ! ? . , & % # * @</code>
                                    </p>

                                    <p className="mb-1">
                                        Cyrillic letters and unsupported special characters will be automatically removed.
                                    </p>

                                    <p className="mb-0 fw-bolder">
                                        Ready? Let’s add your product!
                                    </p>
                                </div>

                                <Row className="mb-0 mt-3 px-0 small">
                                    {/* Первая строка: Title 70% + Author 30% */}
                                    <Col md={12}>

                                        <Form.Group className="mb-2">
                                            <Form.Label className="text-muted small mb-0"> <strong>Enter Amazon Product Title:</strong></Form.Label>
                                            <Form.Control
                                                size="sm"
                                                className="border border-secondary"
                                                value={titleState}
                                                onChange={e => {
                                                    const raw = e.target.value;

                                                    const cleaned = raw
                                                        .replace(/[а-яёА-ЯЁ]/g, '') // удалить кириллицу
                                                        .replace(/:/g, '')          // удалить двоеточия
                                                        .replace(/[^a-zA-Z0-9\s'’\-!?.,&%#*@]/g, ''); // оставить нужные символы (без trim)

                                                    setTitleState(cleaned);
                                                }}
                                                placeholder="Enter Amazon Product Title..."
                                                disabled={loading}
                                                required
                                            />

                                        </Form.Group>
                                    </Col>


                                    {/* Вторая строка: Subtitle на всю ширину */}
                                    <Col xs={6}>
                                        <Form.Group className="mb-2">
                                            <Form.Label className="text-muted small mb-0">
                                                <strong>Enter Manufacturer of your Product:</strong>
                                            </Form.Label>
                                            <Form.Control
                                                size="sm"
                                                className="border border-secondary"
                                                value={subtitleState}
                                                onChange={e => {
                                                    const raw = e.target.value;

                                                    const cleaned = raw
                                                        .replace(/[а-яёА-ЯЁ]/g, '')                     // убрать кириллицу
                                                        .replace(/:/g, '')                              // убрать двоеточия
                                                        .replace(/[^a-zA-Z0-9\s'’\-!?.,()&%#*@]/g, ''); // оставить допустимые символы (без trim)

                                                    setSubTitleState(cleaned);
                                                }}
                                                placeholder="Enter Manufacturer, or type NO if there is none."
                                                disabled={loading}
                                                required
                                            />

                                        </Form.Group>

                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-2">
                                            <Form.Label className="text-muted small mb-0"> <strong>Enter the name of the seller (Sold by):</strong></Form.Label>
                                            <Form.Control
                                                size="sm"
                                                className="border border-secondary"
                                                value={authorState}
                                                onChange={e => {
                                                    let raw = e.target.value;

                                                    let cleaned = raw
                                                        .replace(/^by\s+/i, '')                          // убираем "by" в начале (с пробелом)
                                                        .replace(/\(Author\)$/i, '')                    // убираем "(Author)" в конце (без пробелов)
                                                        .replace(/[а-яёА-ЯЁ]/g, '')                     // убираем кириллицу
                                                        .replace(/:/g, '')                              // убираем двоеточия
                                                        .replace(/[^a-zA-Z0-9\s'’\-!?.,&%#*@]/g, '');   // оставляем только допустимые символы (без trim)

                                                    setAuthorState(cleaned);
                                                }}
                                                placeholder="Enter Enter the name of the seller (Sold by)..."
                                                disabled={loading}
                                                required
                                            />

                                        </Form.Group>

                                    </Col>

                                    {/* Третья строка: кнопка Next по центру */}
                                    <Col xs={12} className="d-flex justify-content-end mt-2">
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-success d-flex align-items-center"
                                            onClick={() => handleStepsChange(step + 1)}
                                            disabled={loading}
                                        >
                                            Next <i className="ms-2 fas fa-arrow-circle-right"></i>
                                        </button>
                                    </Col>
                                </Row>

                            </>
                        ):('')}

                        {nextStep.step1 ? ( // ✅ Проверяем условие
                            <>
                                <div className="text-muted small">


                                    <Row className="align-items-start mb-2">
                                        <Col xs={12} md={10}>
                                            <p className="mb-1">
                                                <strong>Step 4:</strong> Set the <em>product category</em>, <em>listing language</em>, and specify the <em>ASINs</em> with their corresponding prices.
                                                <br />
                                                <span className="text-muted mb-1">
    In this step, choose the main category of your product and the language used on the Amazon listing. Then, enter up to four ASINs representing the same product and its variations (for example, different formats, colors, or sizes), and specify the price for each variation. These parameters help the system correctly link and process your product data.
  </span>
                                            </p>

                                            <p className="text-muted mb-1">
                                                You can paste either the 10-character ASIN code directly, or simply <strong>insert the full Amazon product link</strong> — then click the <em>Extract</em> button.
                                                The system will automatically detect the ASIN from the URL and fill it into the field for you.
                                            </p>

                                            <p className="text-muted mb-1">
                                                Example:
                                                <br />
                                                <code>https://www.amazon.com/Blynkie-Markers-Chisel-Whiteboard-Suitable/dp/B0CZNV4N6J/</code> -> Extract -> will set ASIN <code>B0CZNV4N6J</code>
                                            </p>
                                            <p className="text-muted fst-italic mb-0">
                                                Tip: Each ASIN should belong to the same product family. Using the <em>Extract</em> button helps avoid typing errors and ensures accurate data.
                                            </p>


                                        </Col>
                                        <Col xs={12} md={2} className="d-flex justify-content-md-end justify-content-start mt-2 mt-md-0">
                                            <button
                                                className="btn btn-outline-success btn-sm"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#collapseExample"
                                                aria-expanded={isOpen ? 'true' : 'false'}
                                                aria-controls="collapseExample"
                                                onClick={() => setIsOpen(!isOpen)}
                                            >
                                                Help?
                                            </button>
                                        </Col>
                                    </Row>

                                    <div >

                                        <div className={`collapse ${isOpen ? 'show' : ''}`} id="collapseExample">
                                            <div className="card card-body mb-3">
                                                <div className="mt-0">
                                                    <b className="fw-bold mb-2">Product Setup Guide:</b>
                                                    <ul className="text-muted fst-italic mb-1">
                                                        <li><strong>Category of Product</strong> — Select the most appropriate category that best describes your product type on Amazon.</li>
                                                        <li><strong>Language</strong> — Choose the primary language used on the Amazon listing (for example, English, German, or Spanish).</li>
                                                        <li><strong>Select ASIN’s Quantity</strong> — Indicate how many ASINs your product has (up to four). Each ASIN usually represents a variation of the same product.</li>
                                                        <li><strong>ASIN Fields</strong> — Enter each ASIN exactly as it appears on Amazon. Make sure all provided ASINs belong to the same product family.</li>
                                                        <li><strong>Price Fields</strong> — Specify the price for each ASIN. Prices should match what is currently shown on the corresponding Amazon product pages.</li>
                                                    </ul>
                                                    <p className="fw-normal lh-sm text-danger fw-bolder mb-0 fst-italic">
                                                        Important: Carefully verify all ASINs and their prices before proceeding. Inaccurate or mismatched data (for example, ASINs from different products or outdated prices) can lead to incorrect linking and affect assignment accuracy.
                                                    </p>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    {/* ===== Language / Word Count / Genre ===== */}
                                    <Row className="mb-0 p-2 flex-column flex-md-row small">
                                        <Col xs={12} md={4} className="pe-md-2 mb-2 mb-md-0">
                                            {/* Category of Product */}
                                            <Card className="p-3 border mb-0">
                                                <div className="d-flex flex-column mt-0">
                                                    <span className="text-muted fw-semibold mb-1">Category of Product:</span>
                                                    <Dropdown>
                                                        <Dropdown.Toggle
                                                            variant="small"
                                                            size="sm"
                                                            className="w-100 border small bg-white text-start"
                                                        >
                                                            {book.selectedGenre?.genre || "Select Category"}
                                                        </Dropdown.Toggle>

                                                        <Dropdown.Menu style={{ maxHeight: "200px", overflowY: "auto" }}>
                                                            {book.genres
                                                                .filter((gen) => gen.type === "product")
                                                                .map((gen) => (
                                                                    <Dropdown.Item
                                                                        onClick={() => book.setSelectedGenre(gen)}
                                                                        key={gen.id}
                                                                        className="small text-muted"
                                                                    >
                                                                        {gen.genre}
                                                                    </Dropdown.Item>
                                                                ))}
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                    <div className="d-flex flex-column mt-2 flex-md-row gap-2">

                                                        {/* Language */}
                                                        <div className="flex-grow-1">
                                                            <span className="text-muted fw-semibold mb-1 d-block">Language:</span>
                                                            <Dropdown>
                                                                <Dropdown.Toggle
                                                                    variant="small"
                                                                    size="sm"
                                                                    className="w-100 border small bg-white text-start"
                                                                >
                                                                    {book.selectedLanguage?.language || "Select language"}
                                                                </Dropdown.Toggle>
                                                                <Dropdown.Menu style={{ maxHeight: "200px", overflowY: "auto" }}>
                                                                    {book.languages.map((lang) => (
                                                                        <Dropdown.Item
                                                                            onClick={() => book.setSelectedLanguage(lang)}
                                                                            key={lang.id}
                                                                            className="small text-muted"
                                                                        >
                                                                            {lang.language}
                                                                        </Dropdown.Item>
                                                                    ))}
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </div>


                                                    </div>
                                                    <div className="flex-grow-1">
  <span className="text-muted fw-semibold mt-2 mb-1 d-block">
    Select Asin's quantity:
  </span>

                                                        <Card className="p-2 mt-0 border ">
                                                            <Row>
                                                                <Col xs={6}>
                                                                    <Form.Check
                                                                        className="custom-checkbox mb-1"
                                                                        type="checkbox"
                                                                        label="First Asin"
                                                                        name="kindle_flag"
                                                                        checked={newBook.kindle_flag}
                                                                        onChange={handleCheckboxChange}
                                                                    />
                                                                    <Form.Check
                                                                        className="custom-checkbox mb-1"
                                                                        type="checkbox"
                                                                        label="Second Asin"
                                                                        name="paper_back_flag"
                                                                        checked={newBook.paper_back_flag}
                                                                        onChange={handleCheckboxChange}
                                                                    />
                                                                </Col>

                                                                <Col xs={6}>
                                                                    <Form.Check
                                                                        className="custom-checkbox mb-1"
                                                                        type="checkbox"
                                                                        label="Third Asin"
                                                                        name="hard_cover_flag"
                                                                        checked={newBook.hard_cover_flag}
                                                                        onChange={handleCheckboxChange}
                                                                    />
                                                                    <Form.Check
                                                                        className="custom-checkbox mb-0"
                                                                        type="checkbox"
                                                                        label="Fourth Asin"
                                                                        name="audio_flag"
                                                                        checked={newBook.audio_flag}
                                                                        onChange={handleCheckboxChange}
                                                                    />
                                                                </Col>
                                                            </Row>
                                                        </Card>
                                                    </div>


                                                </div>
                                            </Card>
                                        </Col>

                                        {/* Types (Kindle/Paperback/Hardcover/Audio) */}
                                        <Col xs={12} md={8} className="px-md-2 mb-3 mb-md-0">
                                            <Card className="p-2">
                                                <Row className="mb-2">
                                                    {(newBook.paper_back_flag || newBook.kindle_flag) && (
                                                        <Col md={6} style={{ maxWidth: "100%" }}>
                                                            {newBook.kindle_flag && (
                                                                <Form className="mt-0 mb-0 p-1">
                                                                    <Form.Label className="text-muted fw-semibold mb-0">First ASIN:</Form.Label>
                                                                    <div className="d-flex align-items-center">
                                                                        <Form.Control
                                                                            className="border border-secondary form-control-sm"
                                                                            value={kindleAsinState}
                                                                            onChange={(e) => {
                                                                                const upper = e.target.value.replace(/\s/g, "").toUpperCase();
                                                                                setKindleAsinState(upper);
                                                                            }}
                                                                            placeholder="Enter First ASIN..."
                                                                            disabled={loading}
                                                                        />
                                                                        <Button
                                                                            variant="secondary"
                                                                            className="ms-2 btn-sm"
                                                                            onClick={() => {
                                                                                const upperRaw = kindleAsinState.trim().toUpperCase();
                                                                                const asinMatch = upperRaw.match(/(?:\/dp\/|[?&]asin=)([A-Z0-9]{10})/i);

                                                                                if (asinMatch && asinMatch[1]) {
                                                                                    setKindleAsinState(asinMatch[1]);
                                                                                } else {
                                                                                    const cleaned = upperRaw.replace(/[^A-Z0-9]/g, '');
                                                                                    if (/^[A-Z0-9]{10}$/.test(cleaned)) {
                                                                                        setKindleAsinState(cleaned);
                                                                                    } else {
                                                                                        alert("Couldn't extract a valid ASIN. Please check the link.");
                                                                                    }
                                                                                }
                                                                            }}
                                                                        >
                                                                            Extract
                                                                        </Button>
                                                                        <Button
                                                                            variant="info"
                                                                            className="ms-2 btn-sm"
                                                                            disabled={!kindleAsinState}
                                                                            onClick={async () => {
                                                                                try {
                                                                                    const targetUrl = `${user?.user?.amz_country}/dp/${kindleAsinState}`;
                                                                                    const response = await getRedirectUrlApi(targetUrl);
                                                                                    if (response?.redirectUrl) {
                                                                                        window.open(response.redirectUrl, "_blank", "noopener noreferrer");
                                                                                    } else {
                                                                                        console.error("Failed to get redirect URL");
                                                                                    }
                                                                                } catch (err) {
                                                                                    console.error("Redirect error:", err);
                                                                                }
                                                                            }}
                                                                        >
                                                                            Check
                                                                        </Button>
                                                                    </div>
                                                                </Form>
                                                            )}

                                                            {newBook.paper_back_flag && (
                                                                <Form className="mt-0 mb-0 p-1">
                                                                    <div className="fw-semibold mb-0 text-muted">Second ASIN:</div>
                                                                    <div className="d-flex align-items-center">
                                                                        <Form.Control
                                                                            className="border border-secondary form-control-sm"
                                                                            value={paperbackAsinState}
                                                                            onChange={(e) => {
                                                                                const cleaned = e.target.value.trim().toUpperCase();
                                                                                setPaperBackAsinState(cleaned);
                                                                            }}
                                                                            placeholder="Enter Second ASIN..."
                                                                            disabled={loading}
                                                                        />
                                                                        <Button
                                                                            variant="secondary"
                                                                            className="ms-2 btn-sm"
                                                                            onClick={() => {
                                                                                const raw = paperbackAsinState.trim().toUpperCase();
                                                                                const asinMatch = raw.match(/(?:\/dp\/|[?&]asin=)([A-Z0-9]{10})/i);

                                                                                if (asinMatch && asinMatch[1]) {
                                                                                    setPaperBackAsinState(asinMatch[1]);
                                                                                } else {
                                                                                    const cleaned = raw.replace(/[^A-Z0-9]/g, '');
                                                                                    if (/^[A-Z0-9]{10}$/.test(cleaned)) {
                                                                                        setPaperBackAsinState(cleaned);
                                                                                    } else {
                                                                                        alert("Couldn't extract a valid ASIN. Please check the link.");
                                                                                    }
                                                                                }
                                                                            }}
                                                                        >
                                                                            Extract
                                                                        </Button>
                                                                        <Button
                                                                            variant="info"
                                                                            className="ms-2 btn-sm"
                                                                            disabled={!paperbackAsinState}
                                                                            onClick={async () => {
                                                                                try {
                                                                                    const targetUrl = `${user?.user?.amz_country}/dp/${paperbackAsinState}`;
                                                                                    const response = await getRedirectUrlApi(targetUrl);
                                                                                    if (response?.redirectUrl) {
                                                                                        window.open(response.redirectUrl, "_blank", "noopener noreferrer");
                                                                                    } else {
                                                                                        console.error("Failed to get redirect URL");
                                                                                    }
                                                                                } catch (err) {
                                                                                    console.error("Redirect error:", err);
                                                                                }
                                                                            }}
                                                                        >
                                                                            Check
                                                                        </Button>
                                                                    </div>
                                                                </Form>
                                                            )}

                                                        </Col>
                                                    )}

                                                    {/* Если первая колонка есть → вторая md=6, иначе md=8 (как у тебя было) */}
                                                    <Col md={newBook.paper_back_flag || newBook.kindle_flag ? 6 : 8} style={{ maxWidth: "100%" }}>
                                                        {newBook.hard_cover_flag && (
                                                            <Form className="mt-0 mb-0 p-1">
                                                                <div className="fw-semibold mb-0 text-muted">Third ASIN:</div>
                                                                <div className="d-flex align-items-center">
                                                                    <Form.Control
                                                                        className="border border-secondary form-control-sm"
                                                                        value={hardcoverAsinState}
                                                                        onChange={(e) => {
                                                                            const cleaned = e.target.value.replace(/\s/g, "").toUpperCase();
                                                                            setHardCoverAsinState(cleaned);
                                                                        }}
                                                                        placeholder="Enter Third ASIN..."
                                                                        disabled={loading}
                                                                    />
                                                                    <Button
                                                                        variant="secondary"
                                                                        className="ms-2 btn-sm"
                                                                        onClick={() => {
                                                                            const raw = hardcoverAsinState.trim().toUpperCase();
                                                                            const asinMatch = raw.match(/(?:\/dp\/|[?&]asin=)([A-Z0-9]{10})/i);

                                                                            if (asinMatch && asinMatch[1]) {
                                                                                setHardCoverAsinState(asinMatch[1]);
                                                                            } else {
                                                                                const cleaned = raw.replace(/[^A-Z0-9]/g, '');
                                                                                if (/^[A-Z0-9]{10}$/.test(cleaned)) {
                                                                                    setHardCoverAsinState(cleaned);
                                                                                } else {
                                                                                    toast.info("Couldn't extract a valid ASIN. Please check the link.", { position: "bottom-center", autoClose: 3000, hideProgressBar: false });
                                                                                }
                                                                            }
                                                                        }}
                                                                    >
                                                                        Extract
                                                                    </Button>
                                                                    <Button
                                                                        variant="info"
                                                                        className="ms-2 btn-sm"
                                                                        disabled={!hardcoverAsinState}
                                                                        onClick={async () => {
                                                                            try {
                                                                                const targetUrl = `${user?.user?.amz_country}/dp/${hardcoverAsinState}`;
                                                                                const response = await getRedirectUrlApi(targetUrl);
                                                                                if (response?.redirectUrl) {
                                                                                    window.open(response.redirectUrl, "_blank", "noopener noreferrer");
                                                                                } else {
                                                                                    console.error("Failed to get redirect URL");
                                                                                }
                                                                            } catch (err) {
                                                                                console.error("Redirect error:", err);
                                                                            }
                                                                        }}
                                                                    >
                                                                        Check
                                                                    </Button>
                                                                </div>
                                                            </Form>
                                                        )}

                                                        {newBook.audio_flag && (
                                                            <Form className="mt-0 mb-0 p-1">
                                                                <div className="fw-semibold mb-0 text-muted">Fourth ASIN:</div>
                                                                <div className="d-flex align-items-center">
                                                                    <Form.Control
                                                                        className="border border-secondary form-control-sm"
                                                                        value={audioAsinState}
                                                                        onChange={(e) => {
                                                                            const cleaned = e.target.value.replace(/\s/g, "").toUpperCase();
                                                                            setAudioAsinState(cleaned);
                                                                        }}
                                                                        placeholder="Enter Fourth ASIN..."
                                                                        disabled={loading}
                                                                    />
                                                                    <Button
                                                                        variant="secondary"
                                                                        className="ms-2 btn-sm"
                                                                        onClick={() => {
                                                                            const raw = audioAsinState.trim().toUpperCase();
                                                                            const asinMatch = raw.match(/(?:\/dp\/|[?&]asin=)([A-Z0-9]{10})/i);

                                                                            if (asinMatch && asinMatch[1]) {
                                                                                setAudioAsinState(asinMatch[1]);
                                                                            } else {
                                                                                const cleaned = raw.replace(/[^A-Z0-9]/g, '');
                                                                                if (/^[A-Z0-9]{10}$/.test(cleaned)) {
                                                                                    setAudioAsinState(cleaned);
                                                                                } else {
                                                                                    alert("Couldn't extract a valid ASIN. Please check the link.");
                                                                                }
                                                                            }
                                                                        }}
                                                                    >
                                                                        Extract
                                                                    </Button>
                                                                    <Button
                                                                        variant="info"
                                                                        className="ms-2 btn-sm"
                                                                        disabled={!audioAsinState}
                                                                        onClick={async () => {
                                                                            try {
                                                                                const targetUrl = `${user?.user?.amz_country}/dp/${audioAsinState}`;
                                                                                const response = await getRedirectUrlApi(targetUrl);
                                                                                if (response?.redirectUrl) {
                                                                                    window.open(response.redirectUrl, "_blank", "noopener noreferrer");
                                                                                } else {
                                                                                    console.error("Failed to get redirect URL");
                                                                                }
                                                                            } catch (err) {
                                                                                console.error("Redirect error:", err);
                                                                            }
                                                                        }}
                                                                    >
                                                                        Check
                                                                    </Button>
                                                                </div>
                                                            </Form>
                                                        )}
                                                    </Col>
                                                    <Row>
                                                        <Card.Body>
                                                            <Form className="m-0 mb-0">

                                                                {/* ===== MOBILE (xs–sm): полноширинные поля и кнопки ===== */}
                                                                <div className="d-flex d-md-none flex-column gap-2">
                                                                    {/* Цены */}
                                                                    {newBook.kindle_flag && (
                                                                        <div className="d-flex flex-column">
                                                                            <Form.Label className="text-muted fw-semibold mb-1">First Price:</Form.Label>
                                                                            <Form.Control
                                                                                size="sm"
                                                                                type="text"
                                                                                inputMode="decimal"
                                                                                pattern="[0-9]+([.,][0-9]{1,2})?"
                                                                                placeholder="First Price"
                                                                                value={kindlePriceState}
                                                                                disabled={loading}
                                                                                onChange={(e) => setKindlePriceState(e.target.value)}
                                                                            />
                                                                        </div>
                                                                    )}

                                                                    {newBook.paper_back_flag && (
                                                                        <div className="d-flex flex-column">
                                                                            <Form.Label className="text-muted fw-semibold mb-1">Second:</Form.Label>
                                                                            <Form.Control
                                                                                size="sm"
                                                                                type="text"
                                                                                inputMode="decimal"
                                                                                pattern="[0-9]+([.,][0-9]{1,2})?"
                                                                                placeholder="Second Price"
                                                                                value={paperbackPriceState}
                                                                                disabled={loading}
                                                                                onChange={(e) => setPaperbackPriceState(e.target.value)}
                                                                            />
                                                                        </div>
                                                                    )}

                                                                    {newBook.hard_cover_flag && (
                                                                        <div className="d-flex flex-column">
                                                                            <Form.Label className="text-muted fw-semibold mb-1">Third:</Form.Label>
                                                                            <Form.Control
                                                                                size="sm"
                                                                                type="text"
                                                                                inputMode="decimal"
                                                                                pattern="[0-9]+([.,][0-9]{1,2})?"
                                                                                placeholder="Third Price"
                                                                                value={hardcoverPriceState}
                                                                                disabled={loading}
                                                                                onChange={(e) => setHardcoverPriceState(e.target.value)}
                                                                            />
                                                                        </div>
                                                                    )}
                                                                    {newBook.audio_flag && (
                                                                        <div className="d-flex flex-column">
                                                                            <Form.Label className="text-muted fw-semibold mb-1">Fourth:</Form.Label>
                                                                            <Form.Control
                                                                                size="sm"
                                                                                type="text"
                                                                                inputMode="decimal"
                                                                                pattern="[0-9]+([.,][0-9]{1,2})?"
                                                                                placeholder="Fourth Price"
                                                                                value={fourthPriceState}
                                                                                disabled={loading}
                                                                                onChange={(e) => setFourthPriceState(e.target.value)}
                                                                            />
                                                                        </div>
                                                                    )}
                                                                </div>

                                                                {/* ===== DESKTOP (≥ md): исходная разметка без изменений ===== */}
                                                                <div className="d-none d-md-flex flex-wrap align-items-end gap-0 mt-0 mb-0">
                                                                    {/* левая группа полей */}
                                                                    <div className="d-flex flex-wrap align-items-end gap-3 flex-grow-1">
                                                                        {newBook.kindle_flag && (
                                                                            <div className="d-flex flex-column mt-0" style={{ minWidth: 50, maxWidth: 120 }}>
                                                                                <label className="text-muted fw-semibold">First Price:</label>
                                                                                <Form.Control
                                                                                    size="sm"
                                                                                    type="text"
                                                                                    inputMode="decimal"
                                                                                    pattern="[0-9]+([.,][0-9]{1,2})?"
                                                                                    className="border border-secondary rounded"
                                                                                    placeholder="First Price"
                                                                                    value={kindlePriceState}
                                                                                    disabled={loading}
                                                                                    onChange={(e) => setKindlePriceState(e.target.value)}
                                                                                />
                                                                            </div>
                                                                        )}

                                                                        {newBook.paper_back_flag && (
                                                                            <div className="d-flex flex-column mt-0" style={{ minWidth: 50, maxWidth: 120 }}>
                                                                                <label className="text-muted fw-semibold">Second Price:</label>
                                                                                <Form.Control
                                                                                    size="sm"
                                                                                    type="text"
                                                                                    inputMode="decimal"
                                                                                    pattern="[0-9]+([.,][0-9]{1,2})?"
                                                                                    className="border border-secondary rounded"
                                                                                    placeholder="Second Price"
                                                                                    value={paperbackPriceState}
                                                                                    disabled={loading}
                                                                                    onChange={(e) => setPaperbackPriceState(e.target.value)}
                                                                                    onChange={(e) => setPaperbackPriceState(e.target.value)}
                                                                                />
                                                                            </div>
                                                                        )}

                                                                        {newBook.hard_cover_flag && (
                                                                            <div className="d-flex flex-column mt-0" style={{ minWidth: 50, maxWidth: 120 }}>
                                                                                <label className="text-muted fw-semibold">Third Price:</label>
                                                                                <Form.Control
                                                                                    size="sm"
                                                                                    type="text"
                                                                                    inputMode="decimal"
                                                                                    pattern="[0-9]+([.,][0-9]{1,2})?"
                                                                                    className="border border-secondary rounded"
                                                                                    placeholder="Third Price"
                                                                                    value={hardcoverPriceState}
                                                                                    disabled={loading}
                                                                                    onChange={(e) => setHardcoverPriceState(e.target.value)}
                                                                                />
                                                                            </div>
                                                                        )}
                                                                        {newBook.audio_flag && (
                                                                            <div className="d-flex flex-column mt-0" style={{ minWidth: 50, maxWidth: 120 }}>
                                                                                <label className="text-muted fw-semibold">Fourth Price:</label>
                                                                                <Form.Control
                                                                                    size="sm"
                                                                                    type="text"
                                                                                    inputMode="decimal"
                                                                                    pattern="[0-9]+([.,][0-9]{1,2})?"
                                                                                    placeholder="Fourth Price"
                                                                                    className="border border-secondary rounded"
                                                                                    value={fourthPriceState}
                                                                                    disabled={loading}
                                                                                    onChange={(e) => setFourthPriceState(e.target.value)}
                                                                                />
                                                                            </div>
                                                                        )}

                                                                    </div>


                                                                </div>
                                                                <div className="text-muted" style={{ marginTop: 10, marginBottom: 0 }}>
                                                                    <p style={{ marginBottom: 0 }}>
                                                                        Make sure each ASIN’s price matches the actual price on Amazon. Adjust any incorrect values before saving.
                                                                    </p>
                                                                </div>


                                                            </Form>
                                                        </Card.Body>
                                                    </Row>

                                                </Row>
                                            </Card>
                                        </Col>
                                    </Row>


                                    <div className="d-flex justify-content-end gap-2 mb-0">
                                        <button
                                            type="button"
                                            className="btn btn-secondary btn-sm"
                                            onClick={() => handleStepsChange(step - 1)}
                                            disabled={loading}
                                        >
                                            <i className="me-2 fas fa-arrow-circle-left"></i> Back
                                        </button>

                                        <button
                                            type="button"
                                            className="btn btn-success btn-sm"
                                            onClick={() => handleStepsChange(step + 1)}
                                            disabled={loading}
                                        >
                                            Next <i className="ms-2 fas fa-arrow-circle-right"></i>
                                        </button>
                                    </div>


                                </div>

                            </>
                        ) : null} {/* ✅ Если условие false, ничего не рендерим */}

                        <Row className="justify-content-center">
                            {nextStep.step2 && (
                                <>

                                    <div className="text-muted small">
                                        <Row className="align-items-start mb-2">
                                            <Col xs={12} md={12}>
                                                <p className="mb-0">
                                                    <strong>Step 5:</strong> Upload the main <em>product image</em> and adjust it if necessary.
                                                    <br />
                                                    <span className="text-muted">
    Please upload a clear, high-quality image (JPG or PNG) that represents your product on Amazon.
    After uploading, you can zoom or crop the image to fit standard proportions.
    This image will be used in assignments, listings, and visual materials within the system.
  </span>
                                                </p>


                                            </Col>

                                        </Row>
                                    </div>
                                    <Row className="mt-0">
                                        {/* Левая колонка: Превью, редактор и инструменты */}
                                        <Col md={4} className="p-3">
                                            <div className="card text-center">
                                                <div className="d-flex justify-content-end align-items-center mt-2 mb-0">
                                                    {coverPreview !== defaultImage && (
                                                        <button
                                                            type="button"
                                                            className="btn btn-danger btn-sm d-flex align-items-center me-2 justify-content-center"
                                                            onClick={() => {
                                                                setCoverPreview(defaultImage);
                                                                setCoverFileState(null);
                                                                setShowEditor(false);
                                                                setScale(1);
                                                                saveBookDataToLocalStorage({ cover_file: null, cover_file_name: null });
                                                            }}
                                                            style={{
                                                                width: '20px',
                                                                height: '20px',
                                                                borderRadius: '50%',
                                                                padding: '0',
                                                            }}
                                                        >
                                                            <i className="bi bi-x py-1" style={{ fontSize: '18px' }}></i>
                                                        </button>
                                                    )}
                                                </div>

                                                {showEditor ? (
                                                    <>
                                                        <div ref={parentRef} style={{ width: '100%', maxWidth: '260px', margin: '0 auto' }}>
                                                            <AvatarEditor
                                                                ref={(ref) => setEditorRef(ref)}
                                                                image={coverPreview}
                                                                width={editorSize.width}
                                                                height={editorSize.height}
                                                                border={0}
                                                                scale={scale}
                                                                borderRadius={0}
                                                                className="rounded shadow"
                                                            />
                                                        </div>

                                                        <div className="d-flex justify-content-center align-items-center my-2">
                                                            <i className="bi bi-dash-circle-fill text-success me-2" style={{ fontSize: '1.2rem' }}></i>
                                                            <input
                                                                type="range"
                                                                min="1"
                                                                max="2"
                                                                step="0.01"
                                                                value={scale}
                                                                onChange={(e) => setScale(parseFloat(e.target.value))}
                                                                style={{ width: '150px' }}
                                                            />
                                                            <i className="bi bi-plus-circle-fill text-success ms-2" style={{ fontSize: '1.2rem' }}></i>
                                                        </div>

                                                        <div className="d-flex justify-content-center gap-2 mb-2">
                                                            <select
                                                                value={bookFormat}
                                                                onChange={(e) => setBookFormat(e.target.value)}
                                                                className="form-select form-select-sm w-auto"
                                                            >
                                                                <option value="1x1">1:1 (Square)</option>
                                                                <option value="4x5">4:5 (Vertical)</option>
                                                                <option value="3x4">3:4 (Portrait)</option>
                                                                <option value="2x3">2:3 (Standard)</option>
                                                                <option value="16x9">16:9 (Wide)</option>
                                                                <option value="5x4">5:4 (Rectangular)</option>


                                                            </select>

                                                            <button className="btn btn-success btn-sm" onClick={handleSave}>Save</button>
                                                        </div>
                                                    </>
                                                ) : (
                                                    <div className="p-2" style={{ position: 'relative' }}>
                                                        <img
                                                            src={coverPreview}
                                                            alt="Cover Preview"
                                                            className="img-fluid rounded mt-2 mb-3"
                                                            style={{ maxHeight: '400px', opacity: coverPreview !== defaultImage ? 1 : 0.5 }}
                                                        />
                                                        {!coverFileState && (<>
                                                            <button
                                                                type="button"
                                                                className="btn btn-sm btn-success"
                                                                style={{
                                                                    position: 'absolute',
                                                                    top: '50%',
                                                                    left: '50%',
                                                                    transform: 'translate(-50%, -50%)',
                                                                    padding: '6px 12px',
                                                                    borderRadius: '5px',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    gap: '6px',
                                                                }}
                                                                onClick={triggerFileInput}
                                                                disabled={loading}
                                                            >
                                                                <i className="bi bi-upload"></i> Upload Image
                                                            </button>
                                                        </>)}
                                                    </div>
                                                )}

                                                <input type="file" id="fileInput" style={{ display: 'none' }} onChange={handleFileChange} />
                                            </div>
                                        </Col>

                                        {/* Правая колонка: Инструкции */}
                                        <Col md={8}>
                                            <div className="text-muted small p-2 mt-1 ps-3">
                                                <h6>Instructions for Image Scale and Format:</h6>

                                                <p className="mb-1">
                                                    After uploading your product image, use the slider to adjust the zoom level and select the most suitable aspect ratio to match how your item appears on Amazon.
                                                </p>

                                                <p className="mb-1">
                                                    We recommend choosing the correct ratio (e.g., 1:1 or 4:5) that best represents your product’s layout. This ensures the image looks accurate and professional in listings and promotional materials.
                                                </p>

                                                <p className="mb-1">
                                                    Use the <strong>plus/minus</strong> icons to fine-tune the zoom, then press <strong>Save</strong> to confirm and store your image.
                                                </p>
                                            </div>

                                        </Col>

                                    </Row>
                                    <Row w={100} className="mb-0 m-auto justify-content-center ">

                                        <div className="d-flex justify-content-end gap-2 mb-0">
                                            <button
                                                type="button"
                                                className="btn btn-secondary fflex-md-row btn-sm "
                                                onClick={() => handleStepsChange(step-1)}
                                                disabled={loading}
                                            >
                                                <i className="me-2 fas fa-arrow-circle-left"></i> Back
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-success fflex-md-row btn-sm "
                                                onClick={() => handleStepsChange(step+1)}
                                                disabled={loading}
                                            >
                                                Next <i className="ms-2 fas fa-arrow-circle-right"></i>
                                            </button>
                                        </div>
                                    </Row>
                                </>
                            )}
                        </Row>


                        <Row className="justify-content-center">
                            <Col md={12} className="mt-0">

                                {nextStep.step3 && (
                                    <>
                                        <div className="text-muted small">
                                            <p className="text-muted">
                                                <strong>Step 6:</strong> Write a short and clear description of your product in your own words.
                                                This text helps potential customers quickly understand what the item is, what it’s used for, and why it might be valuable or unique.
                                                <br />
                                                Focus on the key features, materials, or benefits that make your product stand out.
                                                Avoid generic marketing phrases — keep it natural, and easy to read.
                                            </p>



                                            <Form className="mt-0 mb-2 p-2 border-success">
                                                <Form.Control
                                                    as="textarea"
                                                    rows={5}
                                                    value={summaryState}
                                                    onChange={(e) => {
                                                        let raw = e.target.value;

                                                        const cleaned = raw
                                                            .replace(/[а-яёА-ЯЁ]/g, '') // ❌ кириллица
                                                            .replace(/[^\x20-\x7E\r\n\-*•0-9a-zA-Z'"“”’!?.,&#*@]/g, '') // ❌ не ASCII (но сохраняем переносы строк)
                                                            .replace(/(.)\1{4,}/g, '$1$1') // 🔁 aaaaa => aa
                                                            .replace(/[ \t]{2,}/g, ' ') // 🔁 множественные пробелы и табы
                                                            .split('\n')                        // 🔄 разбиваем по строкам
                                                            .map(line => line.trim())          // ✂️ trim каждой строки
                                                            .join('\n')                         // 🔁 склеиваем обратно
                                                            .replace(/\n{3,}/g, '\n\n');       // ❗ 3+ подряд => двойной перенос


                                                        setSummaryState(cleaned);
                                                    }}
                                                    placeholder="Write a short and clear description of your product here..."
                                                    disabled={loading}
                                                    className="text-muted"
                                                    style={{ fontSize: 14 }} // визуально приглушённый стиль
                                                />
                                            </Form>



                                            <>
                                                <Card className="mt-2 border border-secondary bg-secondary bg-opacity-10">
                                                    <Card.Header className="py-1">
                                                        <Form.Check
                                                            type="checkbox"
                                                            id="product-public-catalog-visible"
                                                            label={
                                                                <span className="ms-1">
                                                                    <span className="fw-semibold">I want to place my product in the public product store</span>
                                                                    {publicCatalogVisible
                                                                        ? " — members will be able to discover it in the public product store."
                                                                        : " — your product will not be shown in the public product store."}
                                                                </span>
                                                            }
                                                            checked={publicCatalogVisible}
                                                            onChange={(e) => {
                                                                const v = e.target.checked;
                                                                setPublicCatalogVisible(v);
                                                                saveBookDataToLocalStorage({ public_catalog_visible: v });
                                                            }}
                                                            className="custom-checkbox mt-2 me-2 mb-1"
                                                        />
                                                    </Card.Header>
                                                </Card>

                                                <Row className="justify-content-end me-1 mb-0">

                                                    <div className="mt-3 d-flex justify-content-end ms-4 gap-2">
                                                        <button
                                                            type="button"
                                                            className="btn btn-secondary btn-sm mb-0"
                                                            onClick={() => handleStepsChange(step - 1)}
                                                            disabled={loading}
                                                        >
                                                            <i className="me-2 fas fa-arrow-circle-left"></i> Back
                                                        </button>

                                                        <div className="mt-auto d-flex justify-content-end">
                                                            <button
                                                                type="button"
                                                                className={`btn btn-sm justify-content-end ${isFormValid ? 'btn-success' : 'btn-light'}`}
                                                                onClick={handleSubmitBookToModeration}
                                                                disabled={!isFormValid || loading}
                                                            >
                                                                {loading ? <Spinner as="span" animation="border" size="sm"/> : 'Submit for Moderation'}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </Row>

                                            </>

                                        </div>
                                    </>
                                )}




                            </Col>
                        </Row>


                    </Col>



                </div>


            </Card>
        </>
    );
});

export default addProductInDashboard;
